/* eslint-disable react/display-name, react/prop-types, import/no-cycle */
import React from "react"
import { useSelector } from "react-redux"
import _ from "lodash"

import useWidgetData from "../../hooks/useWidgetData"
import WidgetSkeleton from "../../pages/admin/widgets/WidgetSkeleton"
import WidgetErrorFallback from "./WidgetErrorFallback"
import ErrorBoundary from "../../pages/error/ErrorBoundary"
import CircularProgressBox from "../CircularProgressBox"

export default function withWidgetData(Component) {
  return (props) => {
    const hasMessageToDisplay = useSelector((state) => state.widgets.messages)

    const { widgetId, subscriptions, reqOpt, disableDispatch, disableLoader } =
      props
    const { widgetPreview, data, loading, error } = useWidgetData({
      widgetId,
      subscriptions,
      reqOpt,
      disableDispatch
    })

    if (widgetPreview) {
      return <WidgetSkeleton {...props} />
    }

    if (loading) {
      if (disableLoader) {
        return null
      }
      return <CircularProgressBox height="100vh" />
    }

    // this is a hack to hide Error info box from WidgetErrorFallback
    // see withWidgets which is already rendering NoDataInfoComponent
    // when state.widgets.messages is not empty
    // see comment in 106016
    if (!_.isEmpty(hasMessageToDisplay)) {
      return null
    }

    if (data === undefined && error) {
      return <WidgetErrorFallback type={widgetId} />
    }

    // when inner state of #useWidgetData is not set yet
    // sub component implementation are not safe
    if (data === undefined) {
      return null
    }

    const fwdProps = { ...props, data }
    return (
      <ErrorBoundary type={widgetId} FallbackComponent={WidgetErrorFallback}>
        <Component {...fwdProps} />
      </ErrorBoundary>
    )
  }
}
